import { defineComponent } from '@digitalbranch/app'

import template from './home.page.html'
import css from './home.page.css'

export const homePage = defineComponent({
  name: 'home-page',
  template,
  css,
})
